var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8018_22108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57991 1.41098C3.71588 1.39987 3.87724 1.39989 4.04679 1.3999H10.0428L13.6 5.1349L13.6 12.9531C13.6 13.1226 13.6 13.284 13.5889 13.42C13.5768 13.5682 13.5485 13.7383 13.4619 13.9083C13.3405 14.1466 13.1467 14.3404 12.9084 14.4618C12.7384 14.5485 12.5683 14.5767 12.42 14.5888C12.2841 14.5999 12.1227 14.5999 11.9531 14.5999H4.04675C3.87722 14.5999 3.71587 14.5999 3.57991 14.5888C3.43163 14.5767 3.26156 14.5485 3.09158 14.4618C2.85324 14.3404 2.65946 14.1466 2.53802 13.9083C2.45141 13.7383 2.42315 13.5682 2.41104 13.42C2.39993 13.284 2.39995 13.1226 2.39996 12.9531V3.04673C2.39995 2.87718 2.39993 2.71582 2.41104 2.57985C2.42315 2.43157 2.45141 2.2615 2.53802 2.09152C2.65946 1.85318 2.85324 1.6594 3.09158 1.53796C3.26156 1.45135 3.43163 1.42309 3.57991 1.41098ZM3.59996 2.66644C3.59996 2.62962 3.6298 2.59977 3.66662 2.59977H8.73329V5.93337H12.4V13.3331C12.4 13.3699 12.3701 13.3998 12.3333 13.3998H3.66662C3.6298 13.3998 3.59996 13.3699 3.59996 13.3331V2.66644ZM9.93329 4.73337V3.02477L11.5605 4.73337H9.93329Z",
    fill: "#1B1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 10.2002H4.99998V9.00016H8.33332V10.2002Z",
    fill: "#1B1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 12.2002H8.33332V11.0002H4.99998V12.2002Z",
    fill: "#1B1C1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8018_22108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#878A93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.60684f3a34525c3c9d2f69b3cd8fee89.svg";
export { ForwardRef as ReactComponent };